import styled from 'styled-components'

const ColorWrapper = styled.div<{
  color?: string
  fontWeight?: string
  margin?: string
}>`
  margin: ${({ margin }) => margin || '0 0 8px 0'};
  span {
    color: ${({ color }) => color};
    font-weight: ${({ fontWeight }) => fontWeight};
  }
`

export default ColorWrapper
